import React from "react";
import { useAuthContext } from "../../hooks";
import Navbar from "../../Components/Navbar/index";
import Login from "../../Auth/Login/newIndex";
function Index() {
  const auth = useAuthContext();
  return auth?.isAuthenticated ? (
    <>
      <Navbar />
    </>
  ) : (
    <Login />
  );
}

export default Index;
